import { UserBlockArgs } from 'types/api/arguments/user-block-args'
import { api } from '@marketplace-web/core-api/core-api-client-data'

export const blockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.post(`/users/${currentUserId}/user_hates`, { hated_user_id: blockedUserId })
